import { useState } from "react";
import "./App.css";

// ── Page components ──
import Home         from "./components/home";
import About        from "./components/about";
import Education    from "./components/education";
import Skills       from "./components/skills";
import Projects     from "./components/projects";
import Achievements from "./components/achievements";
import Competitions from "./components/competitions";
import Leaderships  from "./components/leaderships";
import Certificates from "./components/certificates";
import Interests    from "./components/interests";
import Resume       from "./components/resume";
import Contact      from "./components/contact";

const buttons = [
  { id: 1,  label: "Home",         icon: "👤" },
  { id: 2,  label: "About",        icon: "📊",  component: <About /> },
  { id: 3,  label: "Education",    icon: "🎓",  component: <Education /> },
  { id: 4,  label: "Skills",       icon: "💻",  component: <Skills /> },
  { id: 5,  label: "Projects",     icon: "💼",  component: <Projects /> },
  { id: 6,  label: "Achievements", icon: "📁",  component: <Achievements /> },
  { id: 7,  label: "Competitions", icon: "🏆",  component: <Competitions /> },
  { id: 8,  label: "Leaderships",  icon: "🌟",  component: <Leaderships /> },
  { id: 9,  label: "Certificates", icon: "📜",  component: <Certificates /> },
  { id: 10, label: "Interests",    icon: "🎨",  component: <Interests /> },
  { id: 11, label: "Resume",       icon: "📄",  component: <Resume /> },
  { id: 12, label: "Contact",      icon: "📞",  component: <Contact /> },
];

export default function App() {
  const [menuOpen, setMenuOpen]               = useState(false);
  const [hoveredBtn, setHoveredBtn]           = useState(null);
  const [activeContent, setActiveContent]     = useState(null);
  const [menuHovered, setMenuHovered]         = useState(false);
  const [hoveredMenuItem, setHoveredMenuItem] = useState(null);

  const openMenu = (btn) => {
    setMenuOpen(true);
    setActiveContent(btn);
    setMenuHovered(false);
    setHoveredMenuItem(null);
  };

  const closeMenu = () => {
    setMenuOpen(false);
    setActiveContent(null);
    setMenuHovered(false);
    setHoveredMenuItem(null);
  };

  // Navigate to a page by label — used by Home buttons
  const navigateTo = (label) => {
    const btn = buttons.find((b) => b.label === label);
    if (btn) openMenu(btn);
  };

  // Resolve component — Home needs the navigateTo prop injected
  const resolveComponent = (btn) => {
    if (btn.id === 1) return <Home navigateTo={navigateTo} />;
    return btn.component;
  };

  return (
    <div className="app-root">

      {/* ── GRID DEFAULT VIEW ── */}
      <div className={`orbit-view${menuOpen ? " orbit-view--out" : ""}`}>
        <div className="grid-wrap">

          {buttons.map((btn, i) => {
            const positions = [
              "1/1","1/2","1/3","1/4","1/5",
              "2/1",            "2/5",
              "3/1","3/2","3/3","3/4","3/5",
            ];
            const isHov = hoveredBtn === btn.id;
            return (
              <div
                key={btn.id}
                className={`grid-btn${isHov ? " grid-btn--hov" : ""}`}
                style={{ gridArea: positions[i] }}
                onClick={() => openMenu(btn)}
                onMouseEnter={() => setHoveredBtn(btn.id)}
                onMouseLeave={() => setHoveredBtn(null)}
              >
                <span className="grid-btn__icon">{btn.icon}</span>
                <span className="grid-btn__label">{btn.label}</span>
              </div>
            );
          })}

          {/* Center main button */}
          <div className="center-btn" style={{ gridArea: "2/2/3/5" }}>
            <div className="center-btn__accent" />
            <div className="center-btn__inner">
              <span className="center-btn__icon">☰</span>
              <div>
                <div className="center-btn__title">Welcome</div>
                <div className="center-btn__sub">My Professional Portfolio</div>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* ── MENU VIEW ── */}
      <div className={`menu-view${menuOpen ? " menu-view--open" : ""}`}>

        <nav
          className={`sidebar${menuHovered ? " sidebar--wide" : ""}`}
          onMouseEnter={() => setMenuHovered(true)}
          onMouseLeave={() => { setMenuHovered(false); setHoveredMenuItem(null); }}
        >
          <div
            className={`sb-home${hoveredMenuItem === "home" ? " sb-home--hov" : ""}`}
            onClick={closeMenu}
            onMouseEnter={() => setHoveredMenuItem("home")}
            onMouseLeave={() => setHoveredMenuItem(null)}
          >
            <span className="sb-home__glyph">☰</span>
            <span className="sb-home__label">Menu</span>
          </div>

          <div className="sb-divider" />

          {buttons.map((btn) => {
            const on = hoveredMenuItem === btn.id || activeContent?.id === btn.id;
            return (
              <div
                key={btn.id}
                className={`sb-item${on ? " sb-item--on" : ""}`}
                onClick={() => setActiveContent(btn)}
                onMouseEnter={() => setHoveredMenuItem(btn.id)}
                onMouseLeave={() => setHoveredMenuItem(null)}
              >
                <span className="sb-item__icon">{btn.icon}</span>
                <span className="sb-item__label">{btn.label}</span>
              </div>
            );
          })}
        </nav>

        <main className="content" id="resume-scroll-root">
          {activeContent ? (
            <div key={activeContent.id} className="content__body">
              <h1 className="content__title">{activeContent.label}</h1>
              <div className="content__rule" />
              {resolveComponent(activeContent)}
            </div>
          ) : (
            <p className="content__empty">Select an item from the menu</p>
          )}
        </main>
      </div>
    </div>
  );
}